import Cookies from "js-cookie";
import Constraint from "@/lib/common/constraint";

export default class Cookie {
  static get(name: string): string {
    const value = Cookies.get(name);
    return value ? value : "";
  }

  static set(name: string, value: string, expires = 0) {
    let domain = location.hostname;
    const a = domain.split(".");
    let isIp = true;
    if (a.length === 4) {
      for (const i in a) {
        if (isNaN(parseInt(a[i]))) {
          isIp = false;
          break;
        }
      }
    } else {
      isIp = false;
    }
    if (!isIp) {
      if (domain !== "localhost") {
        Cookies.set(name, "", {
          expires: -1,
          domain: domain,
          path: "/"
        });
        Cookies.set(Constraint.tokenKey, "", {
          expires: -1,
          domain: domain,
          path: "/"
        });
        Cookies.set(Constraint.userIdKey, "", {
          expires: -1,
          domain: domain,
          path: "/"
        });
      }

      const items = domain.split(".");
      if (items.length > 2) {
        domain = document.location.hostname.substring(
          document.location.hostname.indexOf(".") + 1
        );
      }
    }
    Cookies.set(name, value, {
      expires: expires,
      domain: domain,
      path: "/"
    });
  }

  static del(name: string) {
    this.set(name, "", -1);
  }
}
